import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createBlock(_component_vue_feather, {
    type: "loader",
    class: _normalizeClass(["rotate", { animated: _ctx.settings.animations }])
  }, null, 8, ["class"]))
}